<template>
  <v-main>
    <v-container>
      <v-row>
        <v-col cols="10" offset="1">
          <v-card class="pa-4" width="100%" text>
            <CardTitle class="justify-center display-3" :title="translate.title" />

            <!-- Presentation  -->
            <CardTitle :title="translate.presentation.title" class="display-1" />
            <CardTitle :title="translate.presentation.subtitle" class="title" />
            <CardText :text="translate.presentation.text" />

            <!-- Propriétaire -->
            <CardTitle :title="translate.owner.title" class="display-1" />
            <CardText :text="translate.owner.text" />

            <!-- Conception et réalisation du site internet -->
            <CardTitle :title="translate.conception.title" class="display-1" />
            <CardText :text="translate.conception.text" />

            <!-- Responsable publication -->
            <CardTitle :title="translate.head.title" class="display-1" />
            <CardText :text="translate.head.text1" />
            <CardText :text="translate.head.text2" />

            <!-- Hébergeur -->
            <CardTitle :title="translate.host.title" class="display-1" />
            <CardText :text="translate.host.text" />

            <!-- Protection des données personnelles -->
            <CardTitle :title="translate.personalData.title" class="display-1" />
            <CardTitle :title="translate.personalData.subtitle" class="title" />
            <CardText :text="translate.personalData.text" />

            <!-- Cookies -->
            <CardTitle :title="translate.cookies.title" class="display-1" />

            <!-- Crédits -->
            <CardTitle :title="translate.credits.title" class="display-1" />
            <ul>
              <li v-for="(item, index) in translate.credits.credits" :key="index">{{ item }}</li>
            </ul>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import CardTitle from '@/components/CardTitle.vue'
import CardText from '@/components/CardText.vue'

export default {
  name: 'LegalNotice',
  components: {
    CardTitle,
    CardText
  },
  computed: {
    translate() {
      return this.$t('legalNotice')
    }
  }
}
</script>
